/* eslint-disable react/prefer-es6-class, react/prop-types, no-confusing-arrow, react/sort-comp */
import React from 'react';
import classnames from 'classnames';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/apps/settings/panel-mixin';

export const SentenceTrainerQuizTypesPanel = React.createClass({
  displayName: 'SentenceTrainerQuizTypesPanel',

  mixins: [PanelMixin],

  statics: {
    getTabName() {
      return t('learning-app.quiz-types');
    },
  },

  /**
   * Get the number of quiz options enabled.
   *
   * @returns {Number}
   */
  _getEnabledQuizOptionsCount() {
    const quizOptions = this.props.userSettings.apps.sentenceStudy.quizOptions;

    return Object.keys(quizOptions)
      .map(type => quizOptions[type] ? 1 : 0)
      .reduce((m, n) => m + n, 0);
  },

  _handleChange(quizOption, value) {
    const attrs = {
      apps: {
        sentenceStudy: {
          quizOptions: {
            [quizOption]: value,
          },
        },
      },
    };

    this.props.onDataChange.call(this, attrs);
  },

  render() {
    const className = classnames('content-columns quiz-types', {
      disabled: this.props.inSession,
    });

    return (
      <div className="quiz-type-settings">
        <div className={className}>
          <section className="content-column dictation-quizzes">
            <h4>{t('dictation-quiz-types')}</h4>

            {this._renderQuizOptionToggle('listeningFillInTheBlankPartial', t('dictation-chunk'), t('dictation-chunk-description'))}
            {this._renderQuizOptionToggle('listeningFillInTheBlank', t('dictation-full'), t('dictation-full-description'))}
          </section>

          <section className="content-column sentence-builder-quizzes">
            <h4 className="primary-item">{t('sentence-builder-quiz-types')}</h4>

            {this._renderQuizOptionToggle('translationAssembly', t('builder-reading'), t('builder-reading-description'))}
            {this._renderQuizOptionToggle('listeningAssembly', t('builder-listening'), t('builder-listening-description'))}
          </section>
        </div>
      </div>
    );
  },

  /**
   * @param {String} quizOption
   * @param {String} title
   * @param {String} description
   */
  _renderQuizOptionToggle(quizOption, title, description) {
    // If in session, disable the quiz. Otherwise, if this is the only
    // quiz type enabled, make sure no one can toggle it. There has to
    // be at least one quiz type enabled.
    const value = this.props.userSettings.apps.sentenceStudy.quizOptions[quizOption];
    const isDisabled = this.props.inSession || (this._getEnabledQuizOptionsCount() === 1 && value);

    return (
      <div className="item-wrapper">
        <span className="primary-item">{title}</span>
        {this._renderToggle(quizOption, value, isDisabled, this._handleChange.bind(null, quizOption))}
        <span className="tertiary-item">{description}</span>
      </div>
    );
  },
});

export default SentenceTrainerQuizTypesPanel;
